import PropTypes from "prop-types";
import { FiAlertTriangle, FiRepeat } from "react-icons/fi";
import Modal from "../../../../utils/components/Modal";
import Button from "../../../../utils/components/Button";
import { bold, boldSuffixed } from "../../../../utils/helpers/boldSuffixed";
import { genitive } from "../../../../utils/helpers/turkishSuffix";

const KEY = "company.users.deactivate";

export const DEACTIVATE_VARIANT = {
  // Open tasks in the selected project and the caller can delegate them (DeactivateWarning.html)
  delegate: "delegate",
  // Open tasks in the selected project but the caller cannot delegate there
  noPermission: "noPermission",
  // Open tasks only in other projects, which this flow neither shows nor delegates
  otherProjects: "otherProjects",
};

// Warning shown instead of deactivating a user who still has open tasks
const DeactivateWarningModal = ({ show, user, count, variant, onCancel, onContinue, translate }) => {
  const t = (key, data) => translate(`${KEY}.${key}`, data);
  const name = user?.name || "";

  const data = {
    name: bold(name),
    name_gen: boldSuffixed(name, genitive),
    open_count: bold(t("open_count", { count })),
  };
  const canContinue = variant === DEACTIVATE_VARIANT.delegate;

  return (
    <Modal show={show} setShow={onCancel} modalSize="md" hideHeader>
      <div className="DeactivateWarningModal text-center">
        <div className="deactivate-warning-icon mx-auto mb-3">
          <FiAlertTriangle />
        </div>
        <h5 className="fw-bold mb-2">{t("title")}</h5>
        <p className="text-secondary mb-0 mx-auto deactivate-warning-body">
          {t(variant === DEACTIVATE_VARIANT.otherProjects ? "other_projects_body" : "body", data)}
        </p>

        {canContinue && <div className="small text-muted mt-3">{t("auto_info")}</div>}

        <div className="d-flex justify-content-center flex-wrap gap-2 mt-4">
          {canContinue ? (
            <>
              <Button className="bg-white" onClick={onCancel}>
                {t("cancel")}
              </Button>
              <Button className="btn-orange text-white fw-bold" onClick={onContinue}>
                <FiRepeat className="me-2" />
                {t("continue")}
              </Button>
            </>
          ) : (
            <Button className="btn-secondary" onClick={onCancel}>
              {t("close")}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

DeactivateWarningModal.propTypes = {
  show: PropTypes.bool,
  user: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  count: PropTypes.number,
  variant: PropTypes.oneOf(Object.values(DEACTIVATE_VARIANT)).isRequired,
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func,
  translate: PropTypes.func.isRequired,
};

export default DeactivateWarningModal;
